import axios from 'axios';
import {
  UPDATE_PARTNER_SIGNUP_INPUT,
  UPDATE_PARTNER_SIGNUP_LICENSE_INPUT,
  UPDATE_PARTNER_SIGNUP_DATA,
  TOGGLE_PARTNER_LICENSE_PROVINCES,
  EMPTY_PARTNER_LOCAL_STORAGE,
  VALIDATE_PARTNER_SIGNUP_LICENSE_INPUT,
  PARTNER_VALIDATION_SUCCESS,
  PARTNER_VALIDATION_FAIL,
  VALIDATE_PARTNER_SIGNUP_INPUT,
  PARTNER_APPLICATION,
  PARTNER_APPLICATION_SUCCESS,
  PARTNER_APPLICATION_FAIL,
  PARTNER_APPLICATION_SERVER_FAIL
} from './types';
import history from '../utility/common/History.js';

const { REACT_APP_API_URL } = process.env;

export const updateSignupData = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PARTNER_SIGNUP_DATA,
      fieldName: fieldName,
      fieldValue: fieldValue
    });
  };
};

export const updateSignupPartnerInputField = (fieldName, fieldValue, fieldGroup) => {
  return {
      type: UPDATE_PARTNER_SIGNUP_INPUT,
      fieldName: fieldName,
      fieldValue: fieldValue,
      fieldGroup: fieldGroup,
  };
};

export const validateSignupPartnerLicenseField = (fieldName, fieldGroup, fieldError) => {
  console.log(fieldError);
  return (dispatch) => {
    dispatch({
      type: VALIDATE_PARTNER_SIGNUP_LICENSE_INPUT,
      fieldName: fieldName,
      fieldGroup: fieldGroup,
      fieldError: fieldError
    });
  };
};

export const validateSignupPartnerInputField = (fieldName, fieldGroup, fieldError) => {
  return {
      type: VALIDATE_PARTNER_SIGNUP_INPUT,
      fieldName: fieldName,
      fieldGroup: fieldGroup,
      fieldError: fieldError
  };
};

export const updateSignupPartnerLicenseField = (fieldName, fieldValue, fieldGroup) => {
  return {
      type: UPDATE_PARTNER_SIGNUP_LICENSE_INPUT,
      fieldName: fieldName,
      fieldValue: fieldValue,
      fieldGroup: fieldGroup,
  };
};


export const toggleSignupPartnerLicenseProvince = (provinceAbriv) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_PARTNER_LICENSE_PROVINCES,
      fieldName: 'enabled',
      fieldGroup: provinceAbriv
    });
  };
}

export const emptyPartnerLocalStorage = () => {
  return (dispatch) => {
    dispatch({
      type: EMPTY_PARTNER_LOCAL_STORAGE
    });
  };
}

export const formApplication = (currentStep) => {

  const url = "/partner/signup";
  history.replace(url);

  return (dispatch) => {
    dispatch({
      type: UPDATE_PARTNER_SIGNUP_DATA,
      fieldName: 'currentSignupStep',
      fieldValue: 0
    });
  };
}

export const reviewApplication = (data) => {

  return (dispatch) => {
    validateApiSignup(dispatch, data);
  };
}


const validatePartnerSuccess = (dispatch, appdata) => {
  dispatch({
    type: PARTNER_VALIDATION_SUCCESS,
    applicationData: appdata
  });
  const url = "/partner/signup/review";
  history.push(url);
};

const validatePartnerFail = (dispatch, appdata) => {
  dispatch({
    type: PARTNER_VALIDATION_FAIL,
    applicationData: appdata
  });
};

export const validateApiSignup = (dispatch, AppData) => {

  axios.post(`${REACT_APP_API_URL}/partner/signup/validate`, {
    appdata: {
      personalInput: AppData.personalInput,
      businessInput: AppData.businessInput,
      personalIDInput: AppData.personalIDInput,
      licenseInput: AppData.licenseInput,
      bankingInput: AppData.bankingInput,
      agreementInput: AppData.agreementInput,
      signupType: AppData.signupType,
      obiManager: AppData.obiManager,
    }
  })
  .then((response) => {
    if (response.data.code === 0) {
      validatePartnerSuccess(
        dispatch,
        response.data.data.appdata,
      );
    }
    else {
      const appdata = response.data && response.data.data ? response.data.data.appdata : null;
      if (appdata) {
        validatePartnerFail(dispatch, appdata);
      } else {
        partnerServerFail(dispatch, response.data?.str || 'An error occurred.');
      }
    }
  })
  .catch((error) => {
    partnerServerFail(
      dispatch,
      error?.message || 'An unexpected error occurred.'
    );
  });
};



const partnerSuccess = (dispatch, appdata) => {
  dispatch({
    type: PARTNER_APPLICATION_SUCCESS,
    applicationData: appdata
  });
  const url = "/partner/signup/thanks";
  history.push(url);
};

const partnerFail = (dispatch, appdata, error) => {
  dispatch({
    type: PARTNER_APPLICATION_FAIL,
    applicationData: appdata
  });
  const url = "/partner/signup/";
  history.push(url);
};

const partnerServerFail = (dispatch, error) => {
  dispatch({
    type: PARTNER_APPLICATION_SERVER_FAIL,
    error: error
  });
  const url = "/partner/signup/";
  history.push(url);
};


export const partnerSignup = (data) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_APPLICATION });
    partnerApiSignup(dispatch, data);
  };
};

export const partnerApiSignup = (dispatch, AppData) => {

  axios.post(`${REACT_APP_API_URL}/partner/signup/submit`, {
    appdata: {
      personalInput: AppData.personalInput,
      businessInput: AppData.businessInput,
      personalIDInput: AppData.personalIDInput,
      licenseInput: AppData.licenseInput,
      bankingInput: AppData.bankingInput,
      agreementInput: AppData.agreementInput,
      signupType: AppData.signupType,
      obiManager: AppData.obiManager,
      error: AppData.error,
    }
  })
  .then((response) => {
    if (response.data.code === 0) {
      partnerSuccess(
        dispatch,
        response.data.data.appdata,
      );
    }
    else {
      const appdata = response.data && response.data.data ? response.data.data.appdata : null;
      if (appdata) {
        partnerFail(dispatch, appdata);
      } else {
        partnerServerFail(dispatch, response.data?.str || 'An error occurred.');
      }
    }
  })
  .catch((error) => {
    partnerServerFail(
      dispatch,
      error?.message || 'An unexpected error occurred.'
    );
  });
};
